/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useCallback, useContext, useEffect, useState } from "react";
import { AutoComplete, Icon, Input, Tooltip, Radio } from "antd";
import loadJS from "load-js";
import useDebounce from "../../../utils/hooks/useDebounce";
import MapPropsContext from "../MapPropsContext";
import {
  KAKAO_MAPS_API_URL,
  TI_ADDRESS_SEARCH_BUTTON,
  TI_FIND_LOCATION_INPUT,
  TI_NAME_SEARCH_BUTTON,
  TI_SEARCH_LOCATION_INPUT,
} from "../../../Constants";
import "./WidgetGeocoding.scss";
import { StyledButton } from "../../../styled-components/Button";

function WidgetGeocoding({ style, zoom, defaultType = "address", onLocationSelectTriggerTable  }) {
  const { viewState, setMapCenter, setDistrictLv1 } =
    useContext(MapPropsContext);

  const [isInit, setIsInit] = useState(false);
  const [locationDataSource, setLocationDataSource] = useState([]);
  const [locationQuery, setLocationQuery] = useState("");
  const [isSearchType, setIsSearchType] = useState(defaultType);

  const onLocationSearch = useCallback(
    (query) => {
      setLocationQuery(query);
    },
    [setLocationQuery]
  );

  useEffect(() => {
    const scriptUrls =
      window.kakao && window.kakao.maps && window.kakao.maps.services
        ? []
        : [KAKAO_MAPS_API_URL];
    loadJS(scriptUrls).then(() => {
      window.kakao.maps.load(() => {
        setIsInit(true);
      });
    });
  }, []);

  useDebounce(
    () => {
      if (locationQuery.length >= 2) {
        if (!isInit) {
          console.error("KAKAO API KEY 설정이 필요합니다.");
        } else {
          const { latitude, longitude } = viewState;
          const places = new window.kakao.maps.services.Places();
          const geocoder = new window.kakao.maps.services.Geocoder();
          if (isSearchType === "keyword") {
            places.keywordSearch(
              locationQuery,
              (result, status) => {
                if (status === window.kakao.maps.services.Status.OK) {
                  const dataSource = result.map(
                    ({ id, place_name, address_name, x, y }) => {
                      return {
                        id,
                        name: place_name,
                        address: address_name,
                        position: { latitude: y, longitude: x },
                      };
                    }
                  );
                  setLocationDataSource(dataSource);
                } else {
                  console.error("failed :", status);
                  setLocationDataSource([]);
                }
              },
              {
                location: new window.kakao.maps.LatLng(latitude, longitude),
              }
            );
          } else if (isSearchType === "address") {
            geocoder.addressSearch(
              locationQuery,
              (result, status) => {
                if (status === window.kakao.maps.services.Status.OK) {
                  const dataSource = result.map(({ address_name, x, y }) => {
                    return {
                      id: address_name,
                      name: address_name,
                      adress: address_name,
                      position: { latitude: y, longitude: x },
                    };
                  });
                  setLocationDataSource(dataSource);
                } else {
                  console.error("failed :", status);
                  setLocationDataSource([]);
                }
              },
              {
                location: new window.kakao.maps.LatLng(latitude, longitude),
              }
            );
          }
        }
      } else {
        setLocationDataSource([]);
      }
    },
    400,
    [isInit, locationQuery]
  );

  const onLocationSelect = useCallback(
    (value) => {
      const {
        position: { latitude, longitude },
        address,
      } = locationDataSource.find(({ id }) => id === value);
      setDistrictLv1(address);
      setMapCenter({ latitude, longitude, zoom });
      if (onLocationSelectTriggerTable) {
        onLocationSelectTriggerTable(); // WidGetTable 호출
      }
    },
    [locationDataSource]
  );

  const changeSearchType = useCallback((event) => {
    setIsSearchType(event.target.value);
  });

  const renderOption = useCallback(({ id, name, address }) => {
    return (
      <AutoComplete.Option key={id} text={name}>
        <div className="global-search-item">
          <span className="global-search-item-desc">{address}</span>
          <span className="global-search-item-count">{name}</span>
        </div>
      </AutoComplete.Option>
    );
  }, []);

  return (
    <div style={{ ...DEFAULT_STYLE, ...style }}>
      <Tooltip title="검색어 입력" placement="right">
        <AutoComplete
          dataSource={locationDataSource.map(renderOption)}
          onSearch={onLocationSearch}
          onSelect={onLocationSelect}
          size={"large"}
          placeholder={"위치를 검색해주세요. (예시: 여의도 또는 여의도동)"}
          optionLabelProp={"text"}
          style={{ width: "100%" }}
        >
          <Input
            aria-label="위치 검색"
            tabIndex={TI_FIND_LOCATION_INPUT}
            suffix={<Icon type="search" className="certain-category-icon" />}
          />
        </AutoComplete>
      </Tooltip>
      <div style={{ textAlign: "right", width: "100%", marginTop: "5px" }}>
        <StyledButton
          isActive={isSearchType === "address"}
          onClick={() => {
            setIsSearchType("address");
            console.log(isSearchType);
          }}
          tabIndex={TI_ADDRESS_SEARCH_BUTTON}
          borderRadius="4px 0px 0px 4px"
        >
          주소검색
        </StyledButton>
        <StyledButton
          isActive={isSearchType === "keyword"}
          onClick={() => {
            setIsSearchType("keyword");
            console.log(isSearchType);
          }}
          tabIndex={TI_NAME_SEARCH_BUTTON}
          borderRadius="0px 4px 4px 0px"
        >
          명칭검색
        </StyledButton>
      </div>
      {/* <Radio.Group
        style={{ textAlign: "right", width: "100%", marginTop: "5px" }}
        value={isSearchType}
        onChange={changeSearchType}
      >
        <Radio.Button value="address" tabIndex={12}>
          주소검색
        </Radio.Button>
        <Radio.Button value="keyword" tabIndex={13}>
          명칭검색
        </Radio.Button>
      </Radio.Group> */}
    </div>
  );
}

const DEFAULT_STYLE = {
  margin: "0px 0px 10px 0px",
};

export default WidgetGeocoding;
